import { useCallback } from 'react';
import { getOrderQuery } from '@/entities/order';
import { useExternalRegistrationCheck } from '@/shared/lib/hooks';

const OZON_ID_REGISTRATION_URL = 'https://www.ozon.ru/ozonid';
const CHECK_DELAY = 3000;

interface UseCheckRegistrationOzonProps {
    orderId: string;
    signature: string;
    storeSlug: string;
}

export const useCheckRegistrationOzon = (props: UseCheckRegistrationOzonProps) => {
    const { orderId, signature, storeSlug } = props;

    const { openRegistration } = useExternalRegistrationCheck({
        checkRegistration: async () => {
            try {
                const response = await getOrderQuery(
                    { order_id: orderId, signature, store_slug: storeSlug },
                    { forceRefetch: true }
                );

                return !response?.client.need_ozon_registration;
            } catch (e) {
                return false;
            }
        },
        checkDelay: CHECK_DELAY,
    });

    return useCallback(() => openRegistration(OZON_ID_REGISTRATION_URL), [openRegistration]);
};
